module.exports = __webpack_public_path__ + "media/images/brands/marisol-page-144de2026930375efd36f92faa382276.png";